<template>
    <div>
      <div v-if="targetAudience">
        Set
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not set
      </div>
    </div>
</template>

<script>
import {
  STEPS,
} from "@/components/FullPageSourceEditorV2/components/AiWriter/constants.js";

export default {
    name: 'ConfigPreviewTargetAudience',
    props: [
        'targetAudience',
    ],
    computed: {
        STEPS() {
          return STEPS
        },
    }
}
</script>

<style lang="scss" scoped>

</style>